import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { UsuarioLoginEntity, UsuarioRespuestaEntity } from './usuario_login_entity';
import { HandleError } from "../../components/common/utils/handleError.component";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { ClienteLogin } from "./cliente_login";
import { UsuarioRegistroEntity } from "../register/entities/usuario_registro_entity";

declare var jQuery: any;
const swal = require("sweetalert2");

@Component({
    selector: 'verificarUsuario',
    templateUrl: 'verificar-usuario.template.html'
})
export class verificarUsuariomaestraComponent implements OnInit {
    usuarioRegistro: UsuarioRegistroEntity;
    usuarioLogin: UsuarioLoginEntity;
    errorMessage: string;
    showLoader: string;
    banderaBrowser: number;
    banderaIE: boolean;
    private sub: any;
    @SessionStorage("usuario")
    user: any;
    @SessionStorage("usuarioLogin")
    userLogin: any;
    @SessionStorage("Token")
    Token: any;
    usuarioRespuesta: UsuarioRespuestaEntity;
    showUsuario: boolean;
    showPregunta: boolean;
    @Output() pregunta = new EventEmitter();

    constructor(
        private sessionStorageService: SessionStorageService,
        private loginService: LoginService,
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError) { }

    checkBrowser() {
        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        //console.log(ua);
        if (msie > 0) {
            // IE 10 or older => return version number
            //return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            this.banderaIE = true;
        } else {

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                //return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                this.banderaIE = true;
            } else {
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    //return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                    this.banderaIE = false;
                } else {
                    // other browser
                    //return false;
                    this.banderaIE = false;
                }
            }
        }
    }

    ngOnInit(): void {
        this.checkBrowser();
        this.banderaBrowser = 0;
        this.usuarioLogin = new UsuarioLoginEntity();

        sessionStorage.clear();
        this.sessionStorageService.clear();

        this.sub = this.route.params.subscribe(params => {
            this.usuarioLogin.Tipo = +params['bandera'];
            if (this.usuarioLogin.Tipo != 1 && this.usuarioLogin.Tipo != 2) {
                this.router.navigate(["/error404"]);
            }
            this.banderaBrowser = this.usuarioLogin.Tipo;
        });
    }

    irInicio()
    {
        this.router.navigate(['/login', this.banderaBrowser]);            
    }

    traerCodigoUsuario() {
        this.loginService.traerCodigoUsuario(this.usuarioLogin.Usuario).subscribe(
            usuario => {

                if (usuario.CodigoUsuario != -1) {
                    
                    if (usuario.TipoUsuario != 1) //si no es super usuario
                    {
                        this.usuarioRespuesta = new UsuarioRespuestaEntity();
                        this.usuarioRespuesta.Usuario = this.usuarioLogin.Usuario;
                        this.usuarioRespuesta.CodigoUsuario = usuario.CodigoUsuario;

                        this.pregunta.emit(this.usuarioRespuesta);
                    }
                    else {
                        this.showLoader = "";
                        swal({
                            title: 'Super usuario',
                            text: "Ud. se encuentra registrado como super usuario en nuestro sistema. Para solicitar el cambio de contraseña por favor comuníquese con su ejecutivo de cuenta.",
                            type: 'warning'
                        });
                    }

                }
                else {
                    this.showLoader = "";
                    swal({
                        title: 'Verificación usuario',
                        text: "Ud. no se encuentra registrado como un usuario en nuestro sistema.",
                        type: 'error'
                    });
                }

            },
            error => {
                this.handleError.redirectUrl(error)
            }
        );
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/verificar-usuarioMaestra.component.ts